export const LoginFailureAction = { type: "ERROR" };
export const LoginLoading = { type: "LOADING" };
export const LoginSuccess = { type: "SUCCESS" };
export const ErrorHandling = { type: "ERRORHANDLING" };